import React from 'react'
import Lottie from 'react-lottie';
import * as animationData from './Play_animation.json';
import "./Play_animation.css"

const Play_animation = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <section className='main'>
            <div className='play_div'>
                <div className='Play_Animation_icon'>
                    <Lottie className="me-auto"
                        options={defaultOptions}
                    />
                </div>
            </div>
        </section>
    )
}

export default Play_animation